(function(){
  if (window.__opInit) return; window.__opInit = true;
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('op-js');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  function scan(){ document.querySelectorAll('.op-reveal:not(.is-in)').forEach(function(el){ io.observe(el); }); }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
})();
